module.exports = __webpack_public_path__ + "static/product_5-4ba9bb90060336423af0220c4daea447.png";